/* eslint-disable consistent-return */
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  cancelHotelBookingApi,
  getHotelBookingDetailsApi,
  // offlineHotelCancellation,
} from '../../../api/hotelApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import '../booking-details/Voucher.scss';
import AppButton from '../../../shared/components/app-button/AppButton';
// import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppModal from '../../../shared/components/app-modal/AppModal';
// import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
// import { NAVIGATION_ROUTES } from '../../../shared/constants/Constants';

function HotelCancellation() {
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [voucher, setVoucher] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setLoading] = useState(false);
  // const [requestedBy, setRequestedBy] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessmodal, setShowSuccessModal] = useState(false);
  const cancellationRef = useRef(undefined);

  const getHotelVoucherDetails = async () => {
    setLoading(true);
    const response = await getHotelBookingDetailsApi(transactionId);
    if (response?.HotelInvoice) {
      const data = response.HotelInvoice || {};
      setVoucher(data);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Voucher Details',
        description:
          response?.Root?.Message ||
          'Error while fetching hotel voucher details',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getHotelVoucherDetails();
  }, []);

  const handleCancelBooking = () => {
    setShowConfirmModal(true);
  };

  const handleOnlineCancellation = async () => {
    setLoading(true);
    setShowConfirmModal(false);
    const res = await cancelHotelBookingApi(transactionId);
    if (res && res.Root?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Hotel Cancellation',
        description: res.Root?.Message,
      });
      const { TransactionStatus } = res.Root;
      cancellationRef.current = TransactionStatus;
      setShowSuccessModal(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hotel Cancellation',
        description: 'Failed to Cancel booking, please try again',
      });
    }
    setLoading(false);
  };

  return (
    <div className="hotel-voucher d-flex">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {voucher !== undefined && (
        <>
          <section className="hotel-voucher_section">
            <div className="hotel-voucher_container">
              <section className="hotel-voucher_heading d-flex  mb-2">
                <h3>Your Booking Summary</h3>
              </section>
              <section className="hotel-details d-flex mb-3">
                <div className="booking-info">
                  <table className="w-100">
                    <tbody>
                      <tr>
                        <td>File No.</td>
                        <td>{voucher.confirmationno}</td>
                      </tr>
                      <tr>
                        <td>Booking Id</td>
                        <td>{voucher.txid}</td>
                      </tr>
                      <tr>
                        <td>Supplier Reference</td>
                        <td>{voucher.supplier_reference}</td>
                      </tr>
                      <tr>
                        <td>Voucher Info</td>
                        <td>{voucher.voucherinfo}</td>
                      </tr>
                      <tr>
                        <td>Booking Status</td>
                        <td>{voucher.booking_status}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="hotel-info ">
                  <table>
                    <tbody>
                      <tr>
                        <td>Hotel Name</td>
                        <td>{voucher.hotel_name}</td>
                      </tr>
                      <tr>
                        <td>Rating</td>
                        <td>{voucher.hotel_rating}</td>
                      </tr>
                      <tr>
                        <td>Address</td>
                        <td>
                          {voucher.hotel_address},{voucher.hotel_cityreference}
                        </td>
                      </tr>
                      <tr>
                        <td>check in </td>
                        <td>{voucher.checkin_time.split(' ')[0]}</td>
                      </tr>
                      <tr>
                        <td>Check Out</td>
                        <td>{voucher.checkout_time.split(' ')[0]}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
              <section className="passenger-details mb-2">
                <table>
                  <thead>
                    <tr>
                      <th>Room Type</th>
                      <th>No Of Rooms</th>
                      <th>No Of Adults</th>
                      <th>No of Children</th>
                      <th>Lead Guest</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{voucher.room_type}</td>
                      <td>{voucher.noof_rooms}</td>
                      <td>{voucher.noof_adults}</td>
                      <td>{voucher.noof_childs}</td>
                      <td>
                        {voucher.leadpassenger_firstname}{' '}
                        {voucher.leadpassenger_lastname}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
              <section className="remarks">
                <table>
                  <thead>
                    <tr>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        *Naming List: Please note that while your booking has
                        been confirmed and is guaranteed, the rooming list with
                        your name may not be adjusted in the hotel reservation
                        system until closer to arrival.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        *Late Arrival: For delayed arrival, please notify your
                        booking office so that we can advise the property
                        accordingly. If you do not arrive on the first night
                        when your accommodation is booked, the property has full
                        right to release your room and charge in full.
                        Therefore, kindly inform in advance to avoid
                        inconvenience in your trip.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        *Please note that every attempt is made to adher to
                        special requests, but they cannot be guaranteed.
                      </td>
                    </tr>

                    <tr>
                      <td>
                        * Credit Card Guarantee: Please note hotels may ask for
                        a credit card imprint or cash depositat the time of
                        check in to cover incidentals. This amount may vary from
                        hotel to hotel.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        If you have a problem with the hotelier or service
                        suppliers regarding the reservations or vouchers, please
                        contact the emergency contact number:
                      </td>
                    </tr>
                    <tr>
                      <td>
                        We hope that you have a wonderful stay and a hassle free
                        trip. In case of any problem during your stay, please
                        feel free to contact us and we would be happy to help
                        you.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Before travelling, please ensure that this reservation
                        has been reconfirmed by your agent. The supplier will
                        not be responsible for an unconfirmed booking
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingBottom: '20px' }}>
                        Thank you for booking with us.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
            <div className="d-flex justify-content-center">
              <AppButton
                btnText="Cancel Booking"
                className="mt-3"
                onClick={handleCancelBooking}
              />
            </div>
          </section>
          <section className="p-3 mt-3">
            {/* <AppTextInput
              label="Requested By"
              placeholderText=""
              value={requestedBy}
              onChange={(e) => setRequestedBy(e.target.value)}
            /> */}
          </section>
          {showConfirmModal && (
            <AppModal
              modalTitle="Hotel Cancellation"
              showCloseButton
              onModalClose={() => setShowConfirmModal(false)}
            >
              <div className="text-center mb-2">
                Do you really want to Cancel the Booking
              </div>
              <div className="d-flex gap-2 justify-content-center">
                <AppButton
                  btnText="Yes"
                  onClick={handleOnlineCancellation}
                  className="px-5"
                />
                <AppButton
                  btnText="No"
                  variant="outlined"
                  className="px-5"
                  onClick={() => setShowConfirmModal(false)}
                />
              </div>
            </AppModal>
          )}
          {showSuccessmodal && (
            <AppModal modalTitle="" onModalClose={() => navigate('/hotel')}>
              <div className=" mb-2 d-flex flex-column gap-2 fs-14 ">
                <span>
                  Your Hotel Booking is cancelled and refund will be processed
                  shortly.
                </span>
                <span>
                  Booking ID: <b>{transactionId}</b>
                </span>
                <span>Status: Cancelled</span>
                <span>
                  Cancellation Reference: <b>{cancellationRef.current}</b>
                </span>
              </div>
              <div className="d-flex justify-content-center gap-3 mt-2">
                <AppButton btnText="Home" onClick={() => navigate('/hotel')} />
                <AppButton
                  btnText="My Bookings"
                  onClick={() =>
                    navigate('/my-bookings?transactionType=hotelBookings')
                  }
                />
              </div>
            </AppModal>
          )}
        </>
      )}
    </div>
  );
}

export default HotelCancellation;
